export function convertPointsToLine(points, setLine) {
    let lines = [];
    points &&
        points.map(point => {
            let lineAux = { points: [] };
            point.pts.map(pointPts => lineAux.points.push(pointPts.x, pointPts.y));
            lines.push(lineAux);
        });
    setLine(lines);
}